import { useEffect, useState } from 'react';

// La revelacion de la clasificacion de una jornada (Jornada::OCULTA en el
// backend): al cerrar su ultimo vino se desenfoca entera, y el panel desvela el
// 3.o, el 2.o y el 1.o; del 4.o para abajo sigue oculto hasta el final, para que
// el ganador no se adivine por descarte. Se pregunta cada pocos segundos para
// verlo en directo.
const CADA_MS = 3000;

export const useRevelacion = () => {
    const [revelacion, setRevelacion] = useState(null);

    useEffect(() => {
        let vivo = true;
        const consultar = () =>
            fetch(`${process.env.REACT_APP_API_URL}/revelacion`)
                .then((respuesta) => (respuesta.ok ? respuesta.json() : { revelacion: null }))
                .then(({ revelacion: nueva }) => {
                    if (!vivo) return;
                    // Solo cambia el estado si cambia algo: asi no se repinta cada 3 s
                    setRevelacion((antes) => (JSON.stringify(antes) === JSON.stringify(nueva) ? antes : nueva));
                })
                .catch(() => {});
        consultar();
        const intervalo = setInterval(consultar, CADA_MS);
        return () => {
            vivo = false;
            clearInterval(intervalo);
        };
    }, []);

    return revelacion;
};

// Lo unico que se desvela puesto a puesto
const PODIO = 3;

// Si un puesto (1, 2, 3...) sigue sin desvelarse: los de fuera del podio, hasta
// que se ve entera (y entonces ya no hay revelacion)
export const oculto = (revelacion, puesto) =>
    Boolean(revelacion) && (puesto > PODIO || puesto < revelacion.visible_desde);

// Clase de lo que se desvela: desenfocado mientras esta oculto, y enfoca al desvelarse
export const claseRevelable = (revelacion, puesto) => 'revelable' + (oculto(revelacion, puesto) ? ' oculta' : '');
